import { applyLayoutToSlide, layersFromLayout } from "../layout/applyLayout.js";
import { designerOutputToContents, designerSystemWithCatalog, parseDesignerResponse, surfDesignerUserPrompt, } from "../layout/designerPrompt.js";
import { designerRoleGuidance } from "../layout/designerHeuristics.js";
import { assertValidDesignerLayers } from "../layout/validateLayout.js";
import { getSurfLayout } from "../layout/templates.js";
import { updateSlideInDeck } from "../editor/deckEditor.js";
import { surfBedrockChat } from "./surfBedrockChat.js";
function slideCopyHints(slide) {
    const titleLayer = slide.layers.find((l) => l.textRole === "title" || l.style?.slotRole === "title");
    const bodyLayer = slide.layers.find((l) => l.textRole === "body" ||
        l.textRole === "bullet" ||
        l.style?.slotRole === "body" ||
        l.style?.slotRole === "bullets");
    const bulletText = slide.layers
        .filter((l) => l.textRole === "bullet" || l.style?.slotRole === "bullets")
        .map((l) => l.content.trim())
        .filter(Boolean)
        .join("\n");
    return {
        headline: titleLayer?.content?.trim() || "Slide",
        body: bodyLayer?.content?.trim() || bulletText || slide.layers.map((l) => l.content).join("\n"),
    };
}
export async function runDesignerForSlide(cfg, deck, slideIndex) {
    const slide = deck.slides[slideIndex];
    if (!slide)
        throw new Error("Slide non trovata.");
    const hints = slideCopyHints(slide);
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.designer.layout",
        systemText: designerSystemWithCatalog(),
        userText: surfDesignerUserPrompt({
            slideIndex,
            slideCount: deck.slides.length,
            headline: hints.headline,
            body: hints.body,
            presentationType: deck.theme.presentationType,
            outlineRole: slide.outlineRole,
            layoutHint: slide.layoutHint,
            roleGuidance: designerRoleGuidance(slide),
        }),
        maxTokens: 4096,
    });
    return parseDesignerResponse(raw);
}
export function applyDesignerOutputToDeck(deck, slideId, output) {
    const layout = getSurfLayout(output.layoutId);
    if (!layout)
        throw new Error(`Layout sconosciuto: ${output.layoutId}`);
    const contents = designerOutputToContents(output);
    const layers = layersFromLayout(layout, contents);
    assertValidDesignerLayers(layers);
    return updateSlideInDeck(deck, slideId, (slide) => applyLayoutToSlide(slide, output.layoutId, contents, {
        theme: deck.theme,
        autoArrange: true,
    }));
}
export async function runDesignerForAllSlides(cfg, deck, onSlide) {
    let next = deck;
    const total = deck.slides.length;
    for (let i = 0; i < total; i += 1) {
        onSlide?.(i, total);
        const slide = next.slides[i];
        const output = await runDesignerForSlide(cfg, next, i);
        next = applyDesignerOutputToDeck(next, slide.id, output);
    }
    return next;
}
